import React, { useEffect, useMemo } from "react"

import { useSettings } from "../../hooks/useSettings"
import { useShopifyProduct } from "../../hooks/useShopify"
import { useAnalytics } from "../../hooks/useAnalytics"
import { useMaintenance } from "../../hooks/useMaintenance"
import { useCheckoutContext, useCheckout } from "../../hooks/useCheckout"
import { useApp } from "../../hooks/useApp"
import { useCore } from "../../hooks/useCore"
import { useShopify } from "../../hooks/useShopify"
import { useNewsletter } from "../../hooks/useNewsletter"

export const withLayout = Component => ({ name = "Layout", location, children, data, path, settings: { settings } }: any) => {
  const { checkout } = useCheckoutContext()
  const {
    organisation: { title },
  } = useSettings()
  const { newsletter } = useNewsletter()
  const { createCheckout } = useCheckout()
  const {
    config: {
      settings: { routes: appRoutes },
    },
    globalStateReducer,
  } = useApp()
  const {
    helpers: { isBrowser },
  } = useCore()
  const { productNormaliser } = useShopify()

  const { active, authorised } = useMaintenance(location)
  const { activeProduct } = useShopifyProduct()
  const { trackEvent } = useAnalytics()

  const [{ activeCart }, dispatch] = globalStateReducer
  //eslint-disable-next-line react-hooks/exhaustive-deps
  const product = useMemo(() => (activeProduct ? productNormaliser(activeProduct) : null), [activeProduct])

  useEffect(() => {
    if (isBrowser) {
      window.okeReviewsWidgetOnInit = function (okendoInitApi) {
        window.okendoInitApi = okendoInitApi
      }
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    trackEvent()
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location?.pathname, checkout])

  useEffect(() => {
    if (!checkout && !activeCart) {
      createCheckout()
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const routes = settings?.routes
  const homepage = location?.pathname === "/"
  const accountPage = useMemo(
    () =>
      location?.pathname?.includes("/account") &&
      !location?.pathname?.includes(appRoutes.LOGIN) &&
      !location?.pathname?.includes(appRoutes.FORGOT) &&
      !location?.pathname?.includes(appRoutes.RESET) &&
      !location?.pathname?.includes(appRoutes.ACTIVATE),
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [location]
  )

  useEffect(() => {
    dispatch({ type: "routeChange", payload: path })
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path])

  Component.displayName = name
  return active ? (
    <>{children}</>
  ) : (
    authorised &&
      useMemo(
        () => (
          <Component
            data={data}
            location={location}
            title={title}
            routes={routes}
            homepage={homepage}
            accountPage={accountPage}
            newsletter={homepage ? newsletter : null}
            product={product}
          >
            {children}
          </Component>
        ),
        //eslint-disable-next-line react-hooks/exhaustive-deps
        [location, homepage, data, product]
      )
  )
}
